import React from 'react';
import { track } from '../modules/tracking';
import PropTypes from 'prop-types';

let Link;

const motion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    (window.matchMedia('(prefers-reduced-motion: no-preference)') || {})
        .matches;

if (motion) {
    Link = require('react-anchor-link-smooth-scroll').default;
}

function getClassName(market) {
    return market === 'IE' ? 'ie splitbanner' : 'splitbanner';
}

function SplitBanner({
    altText,
    section,
    market,
    isClickable = true,
    targetId
}) {
    const sectionId = (section.id || '').replace(/:/g, '_');
    const anchorId = targetId || sectionId;

    function afterClick(e) {
        const hash = (e.target.href || '').split('#')[1];
        const section = document.getElementById(hash);
        let displayName;
        if (section && section.querySelector) {
            displayName =
                (section.querySelector('h2') || {}).innerText || 'Starters';
        }

        track(
            `Dip me baby one more time: Click: Jump page to: ${displayName}`
        )();

        const target = document.getElementById(hash);

        if (target) {
            const anchor = target.querySelector('button');
            if (anchor && anchor.focus) {
                if (motion) {
                    setTimeout(() => {
                        anchor.focus();
                    }, 750);
                } else {
                    anchor.focus();
                }
            }
        }
    }

    let bannerContent = <></>;

    const trackingProps = {
        'data-ga-dmt': 'browsing menu - hero image',
        'data-ga-dmt-cta': 'wrap',
        'data-ga-location': 'hero_1_bm',
        'data-ga-display': 'static panel'
    };

    const linkProps = {
        ...trackingProps,
        href: `#${anchorId}`,
        onClick: afterClick,
        'data-ga-interaction': 'clickable'
    };

    if (!isClickable) {
        bannerContent = <span {...trackingProps}>{altText}</span>;
    } else if (motion) {
        bannerContent = (
            <Link {...linkProps} offset={100}>
                <span>{altText}</span>
            </Link>
        );
    } else {
        bannerContent = (
            <a {...linkProps}>
                <span>{altText}</span>
            </a>
        );
    }

    return <div className={getClassName(market)}>{bannerContent}</div>;
}

SplitBanner.propTypes = {
    altText: PropTypes.string,
    section: PropTypes.object,
    market: PropTypes.string,
    isClickable: PropTypes.bool,
    targetId: PropTypes.string
};

export { SplitBanner };
